import type { ReflectSkillMeta } from "../data/scenarios";
import type { SummativeCriterion, SummativeResult } from "../types";

export const getCriterionPoints = (criterion?: Partial<SummativeCriterion>) =>
	typeof criterion?.score === "number" ? criterion.score : undefined;

export type ScenarioRubricScore = {
	earned: number;
	totalMax: number;
	percentage: number;
	hasScore: boolean;
};

export const computeScenarioRubricScore = (
	result: Partial<SummativeResult> | undefined,
	reflectSkills: ReflectSkillMeta[],
): ScenarioRubricScore => {
	const totalMax = reflectSkills.reduce((sum, meta) => sum + meta.max, 0);
	const criterionPoints = (result?.criteria ?? [])
		.map(getCriterionPoints)
		.filter((points): points is number => points !== undefined);
	const earned = criterionPoints.reduce((sum, points) => sum + points, 0);
	const hasScore = criterionPoints.length > 0;
	const percentage = totalMax ? Math.round((earned / totalMax) * 100) : 0;

	return { earned, totalMax, percentage, hasScore };
};
